import { render, staticRenderFns } from "./SystemCard.vue?vue&type=template&id=8cd1d0b6"
import script from "./SystemCard.vue?vue&type=script&lang=js"
export * from "./SystemCard.vue?vue&type=script&lang=js"
import style0 from "./SystemCard.vue?vue&type=style&index=0&id=8cd1d0b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports